import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  credentialData: {
    cic: "",
    dateOfIssue: "",
    dateOfExpiration: "",
    electorKey: "",
    ocr: "",
  },
  curp: "",
  dateBirth: "",
  email: "",
  gender: "",
  lastName1: "",
  lastName2: "",
  name1: "",
  name2: "",
  nationality: "",
  phone: "",
  placeBirth: "",
  principalAddress: {
    zipCode: "",
    state: "",
    stateId: "",
    stateCRM: "",
    suburbs: "",
    street: "",
    externalNumber: "",
    internalNumber: "",
    townshipId: "",
    township: "",
    country: ""
  },
  processId: "",
};

export const confirmData = createSlice({
  name: "confirmData",
  initialState,
  reducers: {
    addConfirmData: (state, action) => {
      state.credentialData = { ...action.payload };
      state.curp = action.payload.curp;
      state.dateBirth = action.payload.dateBirth;
      state.email = action.payload.email;
      state.gender = action.payload.gender;
      state.lastName1 = action.payload.lastName1;
      state.lastName2 = action.payload.lastName2;
      state.name1 = action.payload.name1;
      state.name2 = action.payload.name2;
      state.nationality = action.payload.nationality;
      state.phone = action.payload.phone;
      state.placeBirth = action.payload.placeBirth;
      state.principalAddress = { ...action.payload };
      state.processId = action.payload.processId;
    },
    changeConfirmData: (state, action) => {
      state.curp = action.payload.curp;
      state.dateBirth = action.payload.dateBirth;
      state.email = action.payload.email;
      state.gender = action.payload.gender;
      state.lastName1 = action.payload.lastName1;
      state.lastName2 = action.payload.lastName2;
      state.name1 = action.payload.name1;
      state.name2 = action.payload.name2;
      state.nationality = action.payload.nationality;
      state.phone = action.payload.phone;
      state.placeBirth = action.payload.placeBirth;
      state.processId = action.payload.processId;
    },
    credentialData: (state, action) => {
      state.credentialData = { ...action.payload };
    },
    principalAddress: (state, action) => {
      state.principalAddress = { ...action.payload };
    },
  },
});

export const {
  addConfirmData,
  changeConfirmData,
  credentialData,
  principalAddress
} = confirmData.actions;
export default confirmData.reducer;
